(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartRecommendations {
    constructor() {
      this.sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
      this.init();
    }

    init() {
      // Use event delegation for dynamically loaded buttons
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.rec-product-card__add-button');
        if (button && !button.disabled) {
          e.preventDefault();
          e.stopPropagation();
          this.handleAddToCart(button);
        }
      });
    }

    async handleAddToCart(button) {
      debugger;
      const variantId = button.dataset.variantId;
      const buttonText = button.querySelector('.rec-product-card__add-text');
      const originalText = buttonText.textContent;
      
      // Set loading state
      button.disabled = true;
      button.classList.add('is-loading');
      
      try {
        // Add to cart
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const data = await response.json();
        
        // Success state
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        buttonText.textContent = '✓ Added';
        
        // Refresh cart drawer
        await this.refreshCart();
        
        // Reset button after delay
        setTimeout(() => {
          button.classList.remove('is-added');
          buttonText.textContent = originalText;
          button.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        
        // Error state
        button.classList.remove('is-loading');
        buttonText.textContent = 'Error';
        
        setTimeout(() => {
          buttonText.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    }

    async refreshCart() {
      try {
        // Get section ID from cart items component
        const sectionId = this.sectionId;
        
        if (!sectionId) {
          console.warn('No section ID found, reloading page');
          window.location.reload();
          return;
        }

        // Fetch updated section
        const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
        const html = await response.text();
        
        // Parse the response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Find cart items component in new HTML
        const newCartItems = doc.querySelector('cart-items-component');
        const currentCartItems = document.querySelector('cart-items-component');
        
        if (newCartItems && currentCartItems) {
          // Replace content
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }
        
        // Update cart count
        const cartData = await fetch('/cart.js').then(r => r.json());
        const cartBubble = document.querySelector('.cart-bubble');
        if (cartBubble) {
          cartBubble.textContent = cartData.item_count;
        }
        
      } catch (error) {
        console.error('Error refreshing cart:', error);
        // Fallback to reload
        window.location.reload();
      }
    }
  }

  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new CartRecommendations();
    });
  } else {
    new CartRecommendations();
  }
  } catch(e) { console.error(e); }
})();

})();
